// src/components/WhyChooseUs.jsx
import React from "react";
import { Link } from "react-router-dom"; 
import "../style/WhyChooseUs.css";

const WhyChooseUs = () => {
  const CDN_BASE = "https://cdn.greateastern.in/GETCO/";

const features = [
  {
    icon: `${CDN_BASE}Untitled_design_3_rw5gpe.png`,
    title: "Best Offers & Prices",
    desc: "Get unbeatable deals on top brands.",
  },
  {
    icon: `${CDN_BASE}Copy_of_Untitled_1_hkggrc.png`,
    title: "Multiple Payment Modes",
    desc: "Flexible options including EMI & cards.",
  },
  {
    icon: `${CDN_BASE}Copy_of_Copy_of_Untitled_1_oir1ls.png`,
    title: "Scheduled Delivery",
    desc: "Quick, hassle-free installations.",
  },
  {
    icon: `${CDN_BASE}Copy_of_Copy_of_Copy_of_Untitled_1_d3sc7x.png`,
    title: "No Cost EMI & Exchange",
    desc: "Upgrade easily with exchange offers.",
  },
  {
    icon: `${CDN_BASE}Copy_of_Copy_of_Copy_of_Copy_of_Untitled_1_jfcor6.png`,
    title: "Extended Warranty",
    desc: "Secure your products for years.",
  },
];


  return (
    <section className="why-choose-section">
      <div className="why-choose-header">
        <h2>Why Choose Great Eastern Trading Co.</h2>
        <p>
          Founded in 1976, Great Eastern Trading Co. has grown over the past 49 years to become one of India’s largest electronics retail chains, with around 99+ outlets across the country.
        </p>
        <p>
          <br></br>
        </p>
      </div>

      <div className="why-choose-grid">
        {features.map((feature, index) => (
          <div className="why-choose-item" key={index}>
            <img src={feature.icon} alt={feature.title} />
            <h4>{feature.title}</h4>
            <p>{feature.desc}</p>
          </div>
        ))}
      </div>

      <div className="why-choose-footer">
  <Link to="/aboutus">
    <button className="connect-btn">About Us</button>
  </Link>
</div>
    </section>
  );
};

export default WhyChooseUs;
